import { Params, redirect } from "react-router-dom";
import { RootStore } from "../../../stores/root-store";
import { Constants } from "../../../globals/constants";
import { LandfillSiteProject } from "../../../stores/project/project";

export async function action(
    params: Params,
    rootStore: RootStore
) {
    if (params.projectCategory !== undefined && params.projectId !== undefined) {
        const projectId = parseInt(params.projectId) || 0;
        const projectCategory = params.projectCategory;
        const rootStoreSession = rootStore.session;

        if (projectCategory === Constants.projectCategoryCreation) {
            await rootStoreSession.projectStore.deleteCreationProject(projectId);
        } else {
            const project = rootStoreSession.projectStore.usageProjects.find(p => p.id === projectId);

            if (project !== undefined && project.typeKey === Constants.projectTypeLandfillSite) {
                await rootStoreSession.compensationStore.delete((project as LandfillSiteProject).compensations[0].id);
                await rootStoreSession.projectStore.deleteCreationProject((project as LandfillSiteProject).recultivationProject.id)
            }

            await rootStoreSession.projectStore.deleteUsageProject(projectId);
        }

        return redirect("/projekte");
    }

    throw new Response("", {
        status: 404,
        statusText: "Projekt wurde nicht gefunden",
    });
}
